export default __webpack_public_path__ + "static/Me-7fd1f3b17c2b2269f505d604a8f58c52.jpg";